import { createAuthRegistry } from './registry';
import { initializeDefaults } from './defaults';
export const defaultRegistry = createAuthRegistry({
  initializer: initializeDefaults
});